<template>
  <div
    id="app"
    :style="{ '--width': width, '--height': height, transformOrigin: '0 0', transform:`scale(${widthFactor},${heightFactor})`}"
  >
    <router-view></router-view>
  </div>
</template>

<script>
// transform:`scale(${widthFactor},${heightFactor}) translate(-${(1-widthFactor)*100}%,-${(1-heightFactor)*100}%)`
import {mapMutations} from "vuex";
let timeoutId;

export default {
  data() {
    return {
		height: '1080px',
		width: '1920px'
	};
  },
  computed: {
    // height() {
    //   return this.$store.state.clientHeight + "px";
    // },
    // width() {
    //   return this.$store.state.clientWidth + "px";
    // }
	  widthFactor() {
		  return this.$store.state.clientWidth / 1920;
	  },
	  heightFactor() {
		  return this.$store.state.clientHeight / 1080;
	  },
  },
  mounted() {
    // 设置窗口宽高
    this.setClientHeight(document.documentElement.clientHeight);
    this.setClientWidth(document.documentElement.clientWidth);
	  console.log(document.getElementById("app"))
    // 监听窗口变化 设置窗口宽高
    window.onresize = (e) => {

      if (!!timeoutId) {
        clearTimeout(timeoutId);
      }
      // timeoutId = setTimeout(() => {
      //   location.reload();
      // }, 500);

      const { clientHeight, clientWidth } =
        e.currentTarget.document.documentElement;
      this.setClientWidth(clientWidth);
      this.setClientHeight(clientHeight);
    };
  },
  methods: {
    ...mapMutations(["setClientHeight", "setClientWidth"]),
  },
};
</script>

<style>
body {
  margin: 0;
  overflow: hidden;
}
.component-container {
  /*width: calc(var(--width) * 0.3);*/
  width: 100%;
  height: calc(var(--height) * 0.925 * 0.3);
  background-image: url(@/assets/images/bg.png);
  background-repeat: round;
  z-index: 5;
  position: relative;
}

.chart-canvas {
  width: 100%;
  height: 100%;
  z-index: 100;
}
.banner {
  position: absolute;
  top: 15px;
  left: 34px;
  z-index: 1;
}
</style>
